import { IMealLoader } from '@/services';
import { Store } from 'vuex';
import { inject, injectable } from 'inversify-props';
import { UniquePromise, ICommand, mcDate, mcLogger } from '@/utils';
import { MealCountKey, MealCountRequest } from '@/models';
import { IState } from '@/store';

/** Pulls down any changes for specified local meals down from the server */
@injectable()
export class SyncMealsDownCommand implements ICommand<MealCountKey[]> {
  @inject() private store!: Store<IState>;
  @inject() private mealLoader!: IMealLoader;

  private promise = new UniquePromise(false);

  /** Fancy colored logger */
  private console: Console = mcLogger.getConsole(this.constructor.name, mcLogger.colors.SyncMealsDownCommand);

  async run(request: MealCountKey[]) {
    return this.promise.run(async () => {
      if (navigator.onLine) {
        this.setRequestSyncDates(request);
        const serverRequest = new MealCountRequest(request);
        await this.mealLoader.loadServerMeals(serverRequest);
      }
    });
  }

  private setRequestSyncDates(mealCountKeys: MealCountKey[]) {
    for (let key of mealCountKeys) {
      const mealCount = this.store.state.meals.mealCountDtos.find(m =>
        m.siteId === key.siteId
        && m.programId === key.programId
        && m.mealTypeId === key.mealTypeId.toUpperCase()
        && mcDate.toShortDate(m.mealServiceDate) === key.mealServiceDate);

      if (mealCount && mealCount.syncDateUtc) {
        key.syncDateUtc = mcDate.toUtcMillis(mealCount.syncDateUtc);
      }
    }
  }
}
